import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  BackofficeConversationExperimentNamesResponseDataSchema,
  DataResponse,
  GetBackofficeConversationExperimentNamesSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeConversationExperimentNamesSchema>
type Response = DataResponse<
  z.infer<typeof BackofficeConversationExperimentNamesResponseDataSchema>
>

const getBackofficeConversationExperimentNamesQueryKey = (query: Query) => [
  "backofficeConversationExperimentNames",
  query,
]

export const getBackofficeConversationExperimentNamesQuery = ({ query }: { query: Query }) => {
  return queryOptions({
    queryKey: getBackofficeConversationExperimentNamesQueryKey(query),
    staleTime: 15 * MINUTES_TO_MILLIS,
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/experiments/names", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
